import React, { useRef } from 'react'
import { useSelector } from 'react-redux'

import { dispatch } from 'store'
import { projectSelectors } from 'store/features/project/selectors'
import { projectThunks } from 'store/features/project/thunks'
import * as Styled from './styled'

const ProjectName: React.FC = () => {
  const { name } = useSelector(projectSelectors.data)
  const ref = useRef<HTMLDivElement>(null)

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      ref.current?.blur()
    }
  }

  const onBlur = (event: React.FocusEvent<HTMLDivElement>) => {
    const innerText = event.target.innerText.trim()

    if ((name === innerText || !innerText) && ref.current) {
      ref.current.textContent = name
      return
    }

    if (innerText) {
      dispatch(projectThunks.updateProjectName(innerText))
    }

    if (ref.current) {
      ref.current.scrollLeft = 0
    }
  }

  return (
    <Styled.ProjectNameContainer>
      <Styled.ProjectName
        contentEditable
        suppressContentEditableWarning
        ref={ref}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
      >
        {name}
      </Styled.ProjectName>
    </Styled.ProjectNameContainer>
  )
}

export default ProjectName
